import { PaymentStoreBase } from "@app/services/stores/shared/PaymentStoreBase";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class PaymentStore extends PaymentStoreBase {
    static $inject = []
    constructor() {
        super("hoapass_payment_", sessionStorage)
    }
}
